<template>
  <div id="adminCrmRequestContact">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ crm }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">{{ requestContact }}</router-link>
      </li>
    </ol>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content noborder">
          <div class="tab-pane nopadding active" id="tabTable" role="tabpanel">
            <div class="card-body">
              <bootstrapTable
                :configurations="tableConfiguration"
                :datas="tableData"
                id="tableContents"
                ref="tableContents"
              ></bootstrapTable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
export default {
  name: "adminCrmRequestContact",
  components: {
    BootstrapTable
  },
  data: function() {
    return {
      admin: dictionaryHelpers.getDictionary("Admin"),
      crm: dictionaryHelpers.getDictionary("CRM"),
      requestContact: dictionaryHelpers.getDictionary("RequestContact"),
      tableConfiguration: [],
      tableData: [],
      url: window.location.pathname
    };
  },
  created() {
    var adminCrmRequestContact = this;

    spinnerHelpers.show();
    adminConfigurationServices.getFunctionality(function(result) {
      if (
        functionHelpers.isValued(result) &&
        functionHelpers.isValued(result.data)
      ) {
        adminCrmRequestContact.tableConfiguration =
          result.data.tablesConfigurations;
      }
      adminCrmRequestContact.loadTable();
    });
  },
  methods: {
    loadTable() {
      var adminCrmRequestContact = this;
      contactRequestServices.getAll(function(result) {
        adminCrmRequestContact.tableData = result.data;
        spinnerHelpers.hide();
      });
    }
  }
};
</script>
